export default __webpack_public_path__ + "static/media/item4.a3b277b6.jpeg";